export const isNullOrUndefined = (value: unknown): boolean => {
  return value === undefined || value === null
}

export const isDefined = <T>(value: T): value is NonNullable<T> => {
  return !isNullOrUndefined(value)
}
